import Badge from "@/tpo/Badge";

export default function DisconnectedBadge({ text = "disconnected" }) {
  return (
    <Badge bg="red" color="white" size="xs">
      {text}
    </Badge>
  );
}
